export enum PaetepCfKeysExtended  {
    CONTEXT_INFO = 'CONTEXT_INFO',
    PAETEP_SIGNATURE = 'PAETEP_SIGNATURE'
}
